module.exports = __webpack_public_path__ + "img/Ancho_Autentico.8658447a.png";